import React from "react";
import {Typography, Box,} from "@mui/material";
import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";
import info from "./img/info_variant1.svg";
import {mugShotNotSupported} from "./PageNavigation";


const BrowserNotSupported = () => {

    const {classes} = MaskSelectorToolStyles();
    const { t } = useTranslation("pages.MaskSelectorTool.StartPage");

    // Localized Strings
    const browserNotSupportedTitle = t("browserNotSupportedTitle");
    const browserNotSupportedDescription = t("browserNotSupportedDescription");

    return (
        <>
            { mugShotNotSupported() && (
                <Box sx={{backgroundColor: "#E5F6FD"}} p={"16px"}
                     className={`${classes.headerFooterContainer} ${classes.browserNotSupportedContainer}`} >
                    <Box className={` ${classes.tipsContentBox}`}>
                        <Box sx={{display: "flex"}}>
                            <Box mr={"10px"}>
                                <img src={info} alt=""/>
                            </Box>
                            <Box>
                                <Typography className={classes.res_heading6}>{browserNotSupportedTitle}</Typography>
                                <Typography className={classes.res_information_text}>{browserNotSupportedDescription}</Typography>
                            </Box>
                        </Box>

                    </Box>
                </Box>
            )}
        </>
    )
};

export default BrowserNotSupported;